var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-list',{staticClass:"flex-grow-1",attrs:{"tool":"daybreak","resolve-entity":_vm.resolveEntity}})
}
var staticRenderFns = []

export { render, staticRenderFns }